import { createAction } from "@reduxjs/toolkit";

export const fetchElencoProntoSoccorso = createAction("FETCH_ELENCO_PRONTO_SOCCORSO@prontoSoccorso");

export const fetchElencoProntoSoccorsoSuccess = createAction("FETCH_ELENCO_PRONTO_SOCCORSO_SUCCESS@prontoSoccorso");

export const fetchElencoProntoSoccorsoFailed = createAction("FETCH_ELENCO_PRONTO_SOCCORSO_FAILED@prontoSoccorso");

export const fetchCodiciColore = createAction("FETCH_CODICI_COLORE@prontoSoccorso");

export const fetchCodiciColoreSuccess = createAction("FETCH_CODICI_COLORE_SUCCESS@prontoSoccorso");

export const fetchCodiciColoreFailed = createAction("FETCH_CODICI_COLORE_FAILED@prontoSoccorso");

export const fetchFaq = createAction("FETCH_FAQ@prontoSoccorso");

export const fetchFaqSuccess = createAction("FETCH_FAQ_SUCCESS@prontoSoccorso");

export const fetchFaqFailed = createAction("FETCH_FAQ_FAILED@prontoSoccorso");

export const fetchCookiePolicy = createAction("FETCH_COOKIE_POLICY@prontoSoccorso");

export const fetchCookiePolicySuccess = createAction("FETCH_COOKIE_POLICY_SUCCESS@prontoSoccorso");

export const fetchCookiePolicyFailed = createAction("FETCH_COOKIE_POLICY_FAILED@prontoSoccorso");

export const fetchContacts = createAction("FETCH_CONTACTS@prontoSoccorso");

export const fetchContactsSuccess = createAction("FETCH_CONTACTS_SUCCESS@prontoSoccorso");

export const fetchContactsFailed = createAction("FETCH_CONTACTS_FAILED@prontoSoccorso");

export const fetchPrivacyPs = createAction("FETCH_PRIVACY_PS@prontoSoccorso");

export const fetchPrivacyPsSuccess = createAction("FETCH_PRIVACY_PS_SUCCESS@prontoSoccorso");

export const fetchPrivacyPsFailed = createAction("FETCH_PRIVACY_PS_FAILED@prontoSoccorso");
